module.exports = __webpack_public_path__ + "static/media/chat-off.5893bcda.svg";